import { lazy } from 'react';

import { whatsappGroupsTranslations as enGroups } from '@/lang/en/whatsappGroups';
import { whatsappGroupsTranslations as esGroups } from '@/lang/es/whatsappGroups';
import { whatsappGroupsTranslations as ptGroups } from '@/lang/pt/whatsappGroups';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

const WhatsappGroupsNavigation = lazy(() =>
  import('./WhatsappGroupsNavigation').then((m) => ({
    default: m.WhatsappGroupsNavigation,
  })),
);

/** WhatsApp group broadcasts with an agent bound to each group. */
export const whatsappGroupsModule: FeatureModule = {
  id: 'whatsapp-groups',
  routes: [{ path: 'groups/*', to: '/app/groups', Component: WhatsappGroupsNavigation }],
  nav: [
    {
      sectionId: 'main',
      order: 50,
      to: '/app/groups',
      label: label('global', 'sidebar_groups_label'),
    },
  ],
  i18n: namespaceBundle('whatsappGroups', { es: esGroups, en: enGroups, pt: ptGroups }),
};
